// extracted by mini-css-extract-plugin
module.exports = {"container":"BusinessFinder_container__ZPMLY","title":"BusinessFinder_title__Q9aQ8","list":"BusinessFinder_list__CUyZf","icon":"BusinessFinder_icon__GFnCe"};